import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiFetch, BACKEND_URL } from '../constants';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);      // Keycloak userinfo claims | null
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await apiFetch('/auth/me');
      setUser(res.ok ? await res.json() : null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    const onUnauth = () => setUser(null);
    window.addEventListener('netgen-unauthorized', onUnauth);
    return () => window.removeEventListener('netgen-unauthorized', onUnauth);
  }, []);

  const logout = useCallback(() => {
    window.location.href = `${BACKEND_URL}/auth/logout`;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
